import { Component, OnInit } from '@angular/core';
import { Hotel } from 'app/shared/model';
import { UtilService } from 'app/shared/util.service';
import { DateService } from 'app/shared/services/date.service';

@Component({
    selector: 'mh-prestay-section-summary',
    templateUrl: './prestay-section-summary.component.html',
    styleUrls: ['./prestay-section-summary.component.scss'],
    standalone: false
})
export class PrestaySectionSummaryComponent implements OnInit {

  productId=4;
  chainFilter: Hotel[] = [];
  /** Hoteles de la zona elegida; el filtro de hoteles se arma con ellos. */
  originalChainFilter: Hotel[] = [];
  isReady:boolean=false;

  fidelityPermisions:string[] = [];

  constructor(
    private utilService: UtilService,
    private dateService: DateService
  ) { }

  ngOnInit() {
    this.fidelityPermisions = this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_prestay');
  }

  setChain(chain: Hotel[]) {
    // Igual que FollowUp corporativo: se aplaza porque el filtro de zona emite durante la detección de cambios
    setTimeout(() => {
      this.originalChainFilter = [...chain];
      this.chainFilter = [...chain];
    }, 0);
  }

  setHotelsFilter(hotels: Hotel[]) {
    this.chainFilter = [...hotels];
  }

  dataIsReady(state){
    setTimeout(_ => {
      this.isReady = state;
    },200);
  }

  handleDatepickerUpdated($event) {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates)
  }

  get currentDates() {
    return this.dateService.currentDates;
  }

  get currentFilterDate() {
    return this.dateService.currentFilter;
  }
}
